// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gender-img[data-v-1aa4a984]{height:55px;width:auto}", ""]);
// Exports
module.exports = exports;
